import React, { ReactElement } from 'react';
import { useSelector } from '@ecommerce/nest-ssr/common';

import Tabs from 'components/tabs/tabs';
import ReviewListDesktop from 'components/review/review-list.desktop';
import CompanyViewInfoDesktop from 'components/company-view/company-view-info/info.desktop';
import type { TabsItemInterface } from 'components/tabs/tabs.interface';
import type { CompanyInterface } from 'interfaces/company.interface';
import type { ReviewInterface } from 'modules/review/review.interface';

import './company-view-tabs.scss';
import { ApiListInterface } from 'interfaces/api.interface';
import { ReviewListParams } from 'modules/review/review-query-params.interface';
import { ReviewStatsPeriodicInterface } from 'interfaces/review-stats.interface';
import { useProductReviews } from 'hooks/use-product-reviews';

const ReviewAdd = React.lazy(() => import('components/review/review-add/review-add'));

const CompanyViewTabsDesktop: React.FC = (): ReactElement => {
    const { company, reviews, params, reviewStatsPeriodic } = useSelector(
        (state: {
            company: CompanyInterface;
            reviews: ApiListInterface<ReviewInterface>;
            params: ReviewListParams;
            reviewStatsPeriodic: ReviewStatsPeriodicInterface[];
        }) => (
            {
                company: state.company,
                reviews: state.reviews,
                params: state.params,
                reviewStatsPeriodic: state.reviewStatsPeriodic
            }
        )
    );
    const { productReviews } = useProductReviews();

    const everStats = reviewStatsPeriodic.find(statsItem => statsItem.period === 'ever');

    const tabs: TabsItemInterface[] = [
        {
            name: `Opinie o ${company.type === 'shop' ? 'sklepie' : 'firmie'} ${company.name}`,
            tabAsHeader: true,
            url: '#opinie',
            component: ReviewListDesktop,
            props: {
                url: `/company/company-reviews/${company.id}`,
                items: reviews.items,
                count: reviews.totalCount || 0,
                ratingStats: everStats && {
                    all: everStats.totalCount,
                    positive: everStats.positiveCount,
                    neutral: everStats.neutralCount,
                    negative: everStats.negativeCount
                },
                company,
                params: params.company,
                objectType: company.type,
                type: 'company'
            },
            isVisible: true
        },
        {
            name: 'Dodaj opinię',
            url: '#zawartosc',
            component: ReviewAdd,
            props: {},
            isLazy: true,
            isVisible: Boolean(company.isReviewable)
        },
        {
            name: 'Opinie o produktach',
            url: '#opinie-o-produktach',
            component: ReviewListDesktop,
            props: {
                url: `/company/product-reviews/${company.id}`,
                items: productReviews.items,
                count: productReviews.totalCount || 0,
                company,
                params: params.product,
                objectType: company.type,
                type: 'product'
            },
            isVisible: company.type === 'shop'
        },
        {
            name: `Dane ${company.type === 'shop' ? 'sklepu' : 'firmy'}`,
            url: '#dane-sklepu',
            component: CompanyViewInfoDesktop,
            props: {
                company
            },
            isVisible: Boolean(company.isCustomer)
        }
    ];

    return (
        <div className="company-view-tabs">
            <Tabs items={tabs} active={0} tabsClassName="container" contentsClassName="container"/>
        </div>
    );
};

export default CompanyViewTabsDesktop;
